import { render, staticRenderFns } from "./ReviewDepositSubmit.vue?vue&type=template&id=2a3d2e6c&scoped=true"
import script from "./ReviewDepositSubmit.vue?vue&type=script&lang=js"
export * from "./ReviewDepositSubmit.vue?vue&type=script&lang=js"
import style0 from "./ReviewDepositSubmit.vue?vue&type=style&index=0&id=2a3d2e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d2e6c",
  null
  
)

export default component.exports